<!-- 
  详情页 - 出库记录
  props:
    id: 详情id
    moduleName: 模块名(合同、工单)
  emit:
    openDetail: 打开详情页
 -->

<template>
  <div class="v-tabs notes-list">
    <div class="head">
      <div class="total">
        累计{{tableData.length}}次出库记录
      </div>
    </div>
    <div class="content" ref="content">
      <ul class="item-list">
        <li class="item center" v-if="!tableData.length">暂无数据</li>
        <li class="item" v-for="item in tableData">
          <span class="date">{{item.addTime}}</span>
          <div class="order">
            <div class="id">
              <i class="ico green">单</i>
              <a @click="openDetail(item.id)">{{item.sheetNo}}</a>
            </div>
            <div class="good">
              <span class="thumb">
                <img :src="item.productImg">
              </span>
              <span class="title">{{item.typeNum}}种商品 共{{item.productNum}}件</span>
            </div>
            <div class="response">负责人：{{item.userName}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    },
    moduleName: {
      type: String
    },
    loading: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      tableData: []
    }
  },
  methods: {
    openDetail (id) {
      this.$emit('openDetail', 'outstock', id)
    },
    getList () {
      let url = '/outstock/relationalList.html'
      let params = {}
      // 不同详情页用到的时候传不同参数（参数名不同）
      if (this.moduleName === 'workOrder') {
        params.workOrderId = this.id
      } else if (this.moduleName === 'contractApi') {
        params.contractId = this.id
      } else if (this.moduleName === 'productionOrder') {
        params.productionOrderId = this.id
      }
      api.post(url, params, (data) => {
        this.tableData = data.productList
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// outstock-log.vue?3506a095